"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _CardSlider = _interopRequireDefault(require("../../CardSlider/CardSlider"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _api = require("../../../content/api");
var _helpers = require("../../../content/helpers/helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FlexBlogPostCarousel = /*#__PURE__*/function (_Component) {
  function FlexBlogPostCarousel() {
    var _this;
    (0, _classCallCheck2["default"])(this, FlexBlogPostCarousel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FlexBlogPostCarousel, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      posts: null
    });
    return _this;
  }
  (0, _inherits2["default"])(FlexBlogPostCarousel, _Component);
  return (0, _createClass2["default"])(FlexBlogPostCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        postCategory = _this$props.postCategory,
        postTag = _this$props.postTag;
      (0, _api.getBlogArticles)(1, postCategory, postTag).then(function (res) {
        return res && _this2.setState({
          posts: res.posts
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var posts = this.state.posts;
      var title = this.props.title;
      if (posts && posts.length) {
        return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("h2", {
          className: "d8-u-ls-sm"
        }, title), /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], null, posts.map(function (highlight) {
          return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
            href: (0, _helpers.getSlug)(highlight)
          }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
            template: "ImageCard",
            imageCardTemplate: "Basic",
            heading: highlight.title.rendered,
            size: "xs",
            bgImage: {
              url: highlight.featured_image_src,
              alt: highlight.title.rendered
            },
            whiteFont: true,
            overlay: true
          }));
        })));
      }
      return null;
    }
  }]);
}(_react.Component);
FlexBlogPostCarousel.propTypes = {
  title: _propTypes["default"].string,
  postCategory: _propTypes["default"].array,
  postTag: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].bool])
};
var _default = exports["default"] = FlexBlogPostCarousel;